<div class="chart">
  <ngx-charts-advanced-pie-chart [valueFormatting]="Formatting" [scheme]="colorScheme" [results]="this.data" [gradient]="gradient"> </ngx-charts-advanced-pie-chart>
</div>
